import React from 'react';
import usePagePhotos from '../../hooks/usePagePhotos';
import Slideone from "../../assets/images/main-slider/slider-1.jpg";
import Slidetwo from "../../assets/images/main-slider/slider-2.jpg";
import Slidethree from "../../assets/images/main-slider/slider-3.jpg";

function TestFallback() {
  const { getPhoto, isUsingCMS, loading, error } = usePagePhotos('home');

  if (loading) {
    return <div>Loading photos...</div>;
  }

  // Test different scenarios
  const tests = [
    {
      name: 'Banner Slide 1 (exists in CMS)',
      key: 'banner_slide_1',
      fallback: Slideone,
      result: getPhoto('banner_slide_1', Slideone)
    },
    {
      name: 'Banner Slide 2 (exists in CMS)', 
      key: 'banner_slide_2',
      fallback: Slidetwo,
      result: getPhoto('banner_slide_2', Slidetwo)
    },
    {
      name: 'Non-existent Photo (should use fallback)',
      key: 'non_existent_photo',
      fallback: Slidethree,
      result: getPhoto('non_existent_photo', Slidethree)
    },
    {
      name: 'Non-existent Photo (no fallback)',
      key: 'another_non_existent',
      fallback: null,
      result: getPhoto('another_non_existent')
    }
  ];

  return (
    <div style={{ padding: '20px' }}>
      <h2>Photo Fallback System Test</h2>
      
      <div style={{ marginBottom: '20px' }}>
        <p><strong>CMS Status:</strong> {isUsingCMS ? 'Enabled' : 'Disabled'}</p>
        <p><strong>Loading:</strong> {loading.toString()}</p>
        <p><strong>Error:</strong> {error ? error.message : 'None'}</p>
      </div>

      <div>
        <h3>Test Results:</h3>
        {tests.map((test, index) => (
          <div key={index} style={{ 
            border: '1px solid #ddd', 
            padding: '15px', 
            margin: '10px 0',
            borderRadius: '8px',
            backgroundColor: test.result ? '#f0f8ff' : '#fff5f5'
          }}>
            <h4>{test.name}</h4>
            <p><strong>Key:</strong> {test.key}</p>
            <p><strong>Has Fallback:</strong> {test.fallback ? 'Yes' : 'No'}</p>
            <p><strong>Result:</strong> {test.result ? 'Found' : 'Not Found'}</p>
            
            {test.result && (
              <div>
                <p><strong>URL:</strong> {test.result.url}</p>
                <p><strong>Alt:</strong> {test.result.alt || 'None'}</p>
                <img 
                  src={test.result.url} 
                  alt={test.result.alt || 'Test image'} 
                  style={{ maxWidth: '200px', maxHeight: '100px', objectFit: 'cover' }}
                  onError={(e) => {
                    e.target.style.backgroundColor = '#ffebee';
                    e.target.style.color = '#c62828';
                    e.target.innerHTML = 'Image Load Failed';
                  }}
                />
              </div>
            )}
          </div>
        ))}
      </div>

      <div style={{ marginTop: '30px', padding: '15px', backgroundColor: '#e8f5e8', borderRadius: '8px' }}>
        <h3>How to Test Different Scenarios:</h3>
        <ol>
          <li><strong>CMS Working:</strong> You should see CMS images loaded</li>
          <li><strong>CMS Failed:</strong> Stop the CMS server and refresh - should see static images</li>
          <li><strong>Missing Photos:</strong> Non-existent keys should use fallbacks or return null</li>
        </ol>
      </div>
    </div>
  );
}

export default TestFallback;